// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_vAE","cls2":"PaperClaiming-cls2_taL PaperClaiming-cls1_vAE"};